import { ReactNode, JSX } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { useStyles } from './card.styles';
import { CardProps } from './card.models';

export const Card = ({ title, content, isTopBorder, isLink, icon }: CardProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div data-testid="card">
      {icon && <img width={64} height={64} className={classes.icon} src={icon} alt="" />}
      <h3
        data-testid="card-title"
        className={cx(classes.title,
          { [classes.titleTopBorder]: isTopBorder },
          { [classes.titleExtLink]: isLink },
        )}
      >
        {intl.formatMessage(
          { id: title },
          { span: (chunk: ReactNode) => <span className={classes.block}>{chunk}</span> },
        )}
      </h3>
      {content.map(item => (
        <p key={item} className={classes.content} data-testid="card-content">
          <FormattedMessage id={item} />
        </p>
      ))}
    </div>
  );
};
